import { CTA, CTA_FINAL } from '../../lib/quizConfig';

export default function QuizResult({ resultado, onCTA }) {
  const { resultadoPrincipal, resultadoSecundario, empate } = resultado;

  return (
    <div className="quiz-result">

      <div className="quiz-result-perfil">
        <p className="quiz-resultado-label">Seu resultado</p>
        <h2 className="quiz-result-nome">{resultadoPrincipal.nome}</h2>
        <p className="quiz-result-texto">{resultadoPrincipal.texto}</p>
      </div>

      {empate && resultadoSecundario && (
        <div className="quiz-result-perfil quiz-result-perfil-secundario">
          <p className="quiz-resultado-label">Também apareceu</p>
          <h2 className="quiz-result-nome">{resultadoSecundario.nome}</h2>
          <p className="quiz-result-texto">{resultadoSecundario.texto}</p>
        </div>
      )}

      <div className="quiz-cta-card">
        <p className="quiz-cta-desc">{CTA_FINAL}</p>
        <button className="btn btn-primary quiz-cta-btn" onClick={onCTA}>
          {CTA.botao}
        </button>
      </div>

      <button
        className="btn btn-ghost quiz-share-btn"
        onClick={() => {
          if (navigator.share) {
            navigator.share({
              title: 'Qual Eu está no comando?',
              text: `Fiz o quiz do Clube do Eu e descobri que tenho o ${resultadoPrincipal.nome}. Faz o seu também →`,
              url: window.location.href,
            });
          } else {
            navigator.clipboard.writeText(window.location.href);
            alert('Link copiado! 📋');
          }
        }}
      >
        📲 Compartilhar meu resultado
      </button>
    </div>
  );
}
